module.exports = __webpack_require__.p + "6efb2cb0a391b971bc94ca3b6f54732c.jpg";